<script lang="ts">
  import { Dialog, DialogContent } from "$lib/components/ui/dialog";

  let { src, alt, open = $bindable() } = $props<{
    src: string | undefined;
    alt: string;
    open: boolean;
  }>();
</script>

<Dialog bind:open={open}>
  <DialogContent class="max-w-[90vw] sm:max-w-[80vw] md:max-w-[70vw] lg:max-w-[60vw] xl:max-w-[50vw] p-0">
    {#if src}
    <img {src} alt={alt} class="w-full h-auto max-h-[80vh] object-contain" />
    {/if}
  </DialogContent>
</Dialog>
